import React from 'react';

const Badge = ({ status }) => {
  const map = {
    active:    'badge-green',
    completed: 'badge-green',
    paid:      'badge-green',
    pending:   'badge-yellow',
    late:      'badge-yellow',
    inactive:  'badge-red',
    suspended: 'badge-red',
    unpaid:    'badge-red',
    SuperAdmin:'badge-purple',
    Admin:     'badge-blue',
    Owner:     'badge-blue',
    Member:    'badge-green',
  };
  return (
    <span className={map[status] || 'badge-blue'}>
      {String(status).charAt(0).toUpperCase() + String(status).slice(1)}
    </span>
  );
};

export default Badge;
